function r(r,t){return{...r,rpcUrls:{...r.rpcUrls,privyWalletOverride:{http:[t]}}}}export{r as addRpcUrlOverrideToChain};
